import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tolgee = defineConnector({
  identifier: "tolgee",
  name: "Tolgee",
  tagLine: "Localization platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://app\\.tolgee\\.io/.*",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Tolgee instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "app.tolgee.io",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Use app.tolgee.io for Tolgee Cloud, or your self-hosted domain.",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Tolgee, go to your project settings and create a new API key. See the [API docs](https://tolgee.io/api) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/v2/api-keys/current`,
  },
});
